<template>
  <div>
    <div
      class="banner-section bg-img"
      v-bind:style="{
        backgroundImage: `url(${require('@/assets/images/banner-img.jpg')})`,
      }"
    >
      <div class="container">
        <div id="search-box" class="filter-box-wrap">
          <div class="iframe-search-form-container">
            <div>
              <div class="main-trip-search search-form pt-30 pb-20">
                <div class="container">

                  <search-form
                    ref="form"
                    form-class="bg-white"
                    :search-form="searchForm"
                    @search="search"
                  >
                  </search-form>

                  <div v-if="false" class="row mt-15">
                    <div
                      class="info-text-container col d-flex justify-content-center align-items-center"
                    >
                      <i
                        class="fas color-white fa-info-circle mr-5 text-white"
                      ></i>
                      <p class="text-white mb-0">
                        If you leave a field blank we will show you all the
                        flights that match what you do fill in
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="banner-txt txtC">
          <h3>
            We connect travelers to share private flights at a fraction of the cost
          </h3>
        </div>
      </div>
    </div>

    <div class="steps-section">
      <div class="container">
        <div class="steps-wrap">
          <ContentBox
            v-bind:key="temp.title"
            v-for="temp of allContent"
            v-bind:name="temp.title"
            v-bind:text="temp.data"
          ></ContentBox>
        </div>
      </div>
    </div>

    <div class="why-choose-section">
      <div class="container">
        <div class="video-section">
          <div class="video-wrap">
            <div class="video-img" v-if="!showVideo">
              <img src="~@/assets/images/video-thumbnail.jpg" />
              <a href="javascript:;" class="play-icon" @click="playVideo">
                <img src="~@/assets/images/play-icon.svg" />
              </a>
            </div>
            <iframe
              id="why-choose-video"
              width="560"
              height="315"
              v-bind:src="
                'https://www.youtube.com/embed/K6px6ahuxH0' +
                (showVideo ? '?autoplay=1' : '')
              "
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="content-box">
            <h3>Why choose to share?</h3>
            <ul>
              <li>
                The more seats filled on a flight, the lower the cost per person
              </li>
              <li>
                Ease through boarding and deplaning while avoiding lines,
                crowds, and waiting
              </li>
              <li>
                Gain valuable time back in your day by flying charter while
                saving money
              </li>
              <li>
                Know who you’ll be sitting next to by approving companions in
                advance
              </li>
            </ul>
          </div>
        </div>
        <div class="content-section">
          <p>
            Welcome to Shared Charter, the social hub for searching, posting,
            and booking shared charter flights! Our goal is to make the
            convenience and comfort of charter flying more affordable.
          </p>
          <p>
            While flying “private” is expensive, sharing it with others makes it
            a reasonable choice for anyone looking for convenience and
            efficiency.
          </p>
          <p>
            Our platform is community-driven, meaning our members post flights
            themselves, and our vetted broker partners help ensure there’s
            always a flight available for you.
          </p>
          <div class="icon-wrap">
            <a href="#search-cta-strip"
              ><img src="~@/assets/images/why-choose-icon.svg"
            /></a>
          </div>
        </div>
      </div>
    </div>

    <div class="membership-section">
      <div class="top-shape">
        <img src="~@/assets/images/btm-curve-new.svg" />
      </div>
      <div class="container">
        <div class="section-title">
          <h2>No Membership or Fees Required</h2>
          <p>
            Get more affordable access to a convenient and comfortable travel
            experience. Anyone can search our flight database!
          </p>
        </div>
        <div class="section-content">
          <div class="cols-wrap">
            <div class="single-col">
              <h4>A successful search</h4>
              <p>
                You have found a flight that someone else has also searched for.
                When you click to join it, we will confirm that they are still
                interested in the trip and if they are, we will arrange secure
                communications with them.
              </p>
            </div>
            <div class="single-col">
              <h4>If your flight search returns no results</h4>
              <p>
                Can’t find your ideal flight in our database? 
                We will automatically add that flight to the database. 
                If you are still interested in the flight when another person finds it, 
                we will provide secure communications between you and the new sharer.
              </p>
            </div>
            <div class="single-col">
              <h4>When someone finds the flight you are interested in</h4>
              <p>
                We will ask if you are still interested in sharing this flight,
                and if you are, we will arrange secure communications between the parties. 
                If you both agree on the flight, our flight concierge will help make the trip happen.
              </p>
            </div>
          </div>
          <div class="btn-wrap dark-blue-btn">
            <a href="#search-box">Search Flights</a>
          </div>
        </div>
      </div>
    </div>

    <div
      class="featurd-section bg-img"
      v-bind:style="{
        backgroundImage: `url(${require('@/assets/images/featured-img-section-bg.jpg')})`,
      }"
    >
      <div class="container">
        <div class="section-title">
          <h2>As featured in</h2>
        </div>
        <div class="section-content">
          <VueSlickCarousel class="logo-slider" v-bind="settings">
            <div class="single-slide">
              <router-link :to="{name:'Media'}"><img class="logo" src="~@/assets/images/HomeIconsAsFeaturedIn/Forbes-logo.jpg" /></router-link>
            </div>
            <div class="single-slide">
              <router-link :to="{name:'Media'}"><img class="logo" src="~@/assets/images/HomeIconsAsFeaturedIn/Yahoo-finance-logo.png" /></router-link>
            </div>
            <div class="single-slide">
              <router-link :to="{name:'Media'}"><img class="logo" src="~@/assets/images/HomeIconsAsFeaturedIn/CJ-logo.jpg" /></router-link>
            </div>
            <div class="single-slide">
              <router-link :to="{name:'Media'}"><img class="logo" src="~@/assets/images/HomeIconsAsFeaturedIn/ain-logo.jpg" /></router-link>
            </div>
            <div class="single-slide">
              <router-link :to="{name:'Media'}"><img class="logo" src="~@/assets/images/HomeIconsAsFeaturedIn/skies-logo.jpg" /></router-link>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

    <div class="search-flight-strip">
      <div class="container">
        <h3>
          Ready to start sharing today? <a href="#search-box">Search Flights</a>
        </h3>
      </div>
    </div>

<!--     <div class="partner-section">
      <div class="container">
        <div class="img-wrap">
          <img src="~@/assets/images/brokers-bg-image.jpg" />
        </div>
        <div class="content-box">
          <h2>Aviation Partners</h2>
          <p>
            Are you a potential partner? You can engage with Shared Charter as
            either an Operator, Broker, or Travel Agent. Post any of your
            clients’ planned flights to save them money, or search our database
            to find an established itinerary that you can have your clients
            join! Partners can post empty leg flights by designating “0” seats
            taken in addition to all other member benefits.
          </p>
          <p>
            To get started, create a partner account by clicking below and
            following the Operator/Broker account creation option.
          </p>
          <div class="btn-wrap dark-blue-btn">
            <router-link to="SignIn"> Create Account</router-link>
          </div>
        </div>
      </div>
    </div> -->
    <div class="testimonial-section">
      <div class="container">
        <div class="section-title">
          <h2>Luxury jet sharing you can trust</h2>
          <p>
            With 60+ years of aviation experience, the SharedCharter founders
            are well-positioned to transform the charter industry. The platform
            connects visitors who want to share the expenses of private flights
            on FAA-certified on-demand air carriers. Our team of experts
            delivers a safe, reliable charter experience at a fraction of the
            cost.
          </p>
        </div>
        <div class="section-content">
          <div class="testimonial-slider">
            <div class="single-slide">
              <div class="content-wrap">
                <p>
                  I am pleased to be a member of SharedCharter, and I anticipate
                  using your service for my future private flights. Your many
                  years of experience—both as a pilot and aviation follower—are
                  of great value in times like these. Innovative efforts are
                  appreciated.
                </p>
              </div>
              <div class="personal-detail">
                Murray Zedeck, DO<br />
                FAA Medical Examiner, Retired.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="download-app-section bg-img"
      v-bind:style="{
        backgroundImage: `url(${require('@/assets/images/SharedCharter_AppBanner-1600x600.jpg')})`,
      }"
    >
      <div class="container">
        <div class="section-title">
          <h2>Share a charter flight</h2>
          <p>Download the SharedCharter APP</p>
        </div>
        <div class="downld-link-btn">
          <a class="downld-link-single-btn" target="_blank" href="https://play.google.com/store/apps/details?id=com.shared_charter.app"><img src="~@/assets/images/Droid-Botton.png" /></a>
          <a class="downld-link-single-btn" target="_blank" href="https://apps.apple.com/ar/app/shared-charter/id1544998096?l=en" ><img src="~@/assets/images/IOS-Botton.png" /></a>
        </div>
        <div class="companies-logos-container mt-5">
          <img src="~@/assets/images/company-logos.png" />
        </div>
      </div>
    </div>

    <div class="download-app-section mobile">
      <div class="container">
        <div class="section-title">
          <h2>Share a charter flight</h2>
          <p>Download the SharedCharter APP</p>
        </div>
        <div class="downld-link-btn">
          <a class="downld-link-single-btn mb-20" target="_blank" href="https://play.google.com/store/apps/details?id=com.shared_charter.app"><img src="~@/assets/images/Droid-Botton.png" /></a>
          <a class="downld-link-single-btn" target="_blank" href="https://apps.apple.com/ar/app/shared-charter/id1544998096?l=en" ><img src="~@/assets/images/IOS-Botton.png" /></a>
        </div>
        <div class="smartphone-image-container">
          <img :src="require('@/assets/images/SharedCharter_AppBanner-mobil.jpg')" alt="">
        </div>
      </div>

    </div>

    <div
      id="search-cta-strip"
      class="search-flight-cta-section bg-img"
      v-bind:style="{
        backgroundImage: `url(${require('@/assets/images/cta-strip-bg.jpg')})`,
      }"
    >
      <div class="container">
        <div class="section-title">
          <h2>We’re here to help.</h2>
          <h4>
            Call our support line at 561-273-9999 and our travel concierge will
            do everything they can to answer any questions you may have.
          </h4>
          <div class="btn-wrap sky-blue-btn">
            <a href="#search-box">Search Flights</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import ContentBox from "./ContentBox/ContentBox";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import SearchFlightMixin from '../../mixins/SearchFlightMixin';
import SearchHelpersMixin from '../../mixins/SearchHelpersMixin';
import SearchForm from '../Trips/Forms/SearchForm';

export default {
  name: "Home",
  metaInfo: {
            title: 'Shared Charter | Affordable Private Air Charters',
            meta: [
                {
                    name: 'description',
                    content: 'Find private air travel at fractions of the cost. Shared Charter provides comfortable &amp; convenient private jets with no commitments required.'
                },
            ]
        },
  components: { VueSlickCarousel, ContentBox, SearchForm },
  mixins: [SearchFlightMixin, SearchHelpersMixin],
  // components: { VueSlickCarousel, ContentBox },
  data() {
    return {
      guestInputs: {
          guest_email: null,
          guest_phone: null
      },
      searchForm: {
          airportFrom: null,
          airportTo: null,
          dateRange: '',
      },
      results: null,
      showVideo: false,
      allContent: [
        {
          title: "SEARCH",
          data:
            "Search our database of flights to see if one matches your own itinerary requirements. If your flight search comes up empty, it will automatically be added to the flight database for others to find and we will email you when there is a match.",
        },
        {
          title: "CONNECT",
          data:
            "When someone finds your flight, we’ll contact you to see if you are still interested in sharing the flight. If you are, we’ll arrange for you to communicate securely with your potential companions. When an agreement is reached our travel concierge will book your shared flight.",
        },
        {
          title: "FLY",
          data:
            "Avoid airport lines and all of the other stresses of commercial travel. Fly in comfort and convenience with other SharedCharter travelers for a fraction of the charter’s cost.",
        },
      ],
      settings: {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      },
    };
  },
  methods: {
    updateRoute() {
      this.$router.push({name:'TripSearch',query: this.getRoute()})
    },
    playVideo() {
      this.showVideo = true;
    },
  },
};
</script>

<style >
.banner-section {
  min-height: 520px;
  padding-top: 50px;
}
.banner-section .banner-txt {
  max-width: 800px;
  margin: 0 auto 0;
}
.banner-section .banner-txt h3 {
  font-weight: 500;
  color: #000234;
}
.banner-section .filter-box-wrap .form-wrap {
  max-width: 975px;
  margin: 0 auto 20px;
  box-shadow: 6px 6px 9px rgb(0 0 0 / 16%);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 20px 30px;
}
.banner-section .filter-box-wrap .form-wrap input {
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  border-radius: 5px;
  border: 1px solid #dddddd;
  background-color: #ffffff;
  padding: 13px 10px;
  font-size: 15px;
  margin-right: 5px;
  width: 250px;
  height: 55px;
}
.banner-section .filter-box-wrap .form-wrap input[type="text"] {
  padding: 15px 10px;
}
.banner-section .filter-box-wrap .form-wrap input[type="submit"] {
  background-color: #2597d8;
  font-size: 18px;
  color: #fff;
  border: 0;
  box-shadow: none;
  text-transform: uppercase;
  font-weight: 700;
  padding: 14.5px 15px;
}
.banner-section .filter-box-wrap .form-wrap input[type="submit"]:hover {
  background-color: #1a2d74;
}
.banner-section .filter-box-wrap .form-wrap input:last-child {
  margin-right: 0;
  max-width: 100px;
}
.banner-section .filter-box-wrap .form-wrap form {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.banner-section .filter-box-wrap .form-wrap form a img {
  display: block;
}

.steps-section {
  padding-bottom: 360px;
}
.steps-section .steps-wrap {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: -240px;
  display: flex;
}
.steps-section .steps-wrap .single-box {
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  width: calc(33.33% - 30px);
  margin: 0 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
}
.steps-section .steps-wrap .single-box .img-wrap {
  max-height: 240px;
  overflow: hidden;
}
.steps-section .steps-wrap .single-box .img-wrap img {
  display: block;
  width: 100%;
  height: 240px;
  object-fit: cover;
}
.steps-section .steps-wrap .single-box .content-wrap {
  padding: 20px 25px 30px;
  text-align: center;
  font-weight: 500;
}
.steps-section .steps-wrap .single-box .content-wrap h4 {
  text-transform: uppercase;
  margin-bottom: 5px;
}

.why-choose-section {
  padding-top: 70px;
  background-color: #000234;
  padding-bottom: 70px;
  position: relative;
}
.why-choose-section .video-section {
  display: flex;
  align-items: center;
  max-width: 1070px;
  margin: -310px auto 60px;
}
.why-choose-section .video-section .video-wrap {
  width: 100%;
  max-width: 570px;
  position: relative;
}
.why-choose-section .video-section .video-wrap iframe {
  display: block;
  width: 100%;
  border-radius: 10px;
  box-shadow: 6px 6px 9px rgb(0 0 0 / 16%);
}
.why-choose-section .video-section .video-wrap .video-img {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
}
.why-choose-section .video-section .video-wrap .video-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.why-choose-section .video-section .video-wrap .video-img a {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.why-choose-section .video-section .content-box {
  background-color: #f2f2f2;
  border-radius: 20px;
  padding: 86px 55px 86px 180px;
  margin-left: -150px;
}
.why-choose-section .video-section .content-box h3 {
  margin-bottom: 15px;
}
.why-choose-section .video-section .content-box ul li {
  font-weight: 500;
  padding-left: 20px;
  margin-bottom: 10px;
  position: relative;
}
.why-choose-section .video-section .content-box ul li:before {
  content: "";
  width: 6px;
  height: 6px;
  background-color: #2597d8;
  position: absolute;
  left: 4px;
  top: 8px;
  border-radius: 50%;
}
.why-choose-section .content-section {
  text-align: center;
  font-size: 20px;
  line-height: 30px;
  color: #fff;
  max-width: 950px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.why-choose-section .content-section .icon-wrap {
  width: 100px;
  height: 100px;
  background: #2597d8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 60px auto 0;
  position: relative;
  margin-bottom: -230px;
  z-index: 1;
  box-shadow: 0 0 20px rgb(0 0 0 / 15%);
}

.membership-section {
  padding: 210px 0 60px;
  position: relative;
}
/*.membership-section:before{content:'';width:100%;height:130px;background-image:url(../images/btm-curve-new.svg);position:absolute;top:0;left:0;background-repeat:no-repeat;background-size:cover;background-position:bottom;}
*/
.membership-section .top-shape {
  position: absolute;
  top: -48px;
  width: 100%;
  height: 173px;
}
.membership-section .top-shape img {
  width: 100%;
  height: 175px;
  object-position: bottom;
  filter: drop-shadow(0px 12px 20px rgba(0, 0, 0, 0.15));
}
.membership-section .section-title {
  text-align: center;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 30px;
}
.membership-section .section-title p {
  font-size: 20px;
  line-height: 30px;
  color: #1a2d74;
  font-weight: 500;
}
.membership-section .cols-wrap {
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
}
.membership-section .cols-wrap .single-col {
  color: #707070;
  width: calc(33.33% - 30px);
  margin: 0 15px;
}
.membership-section .section-content .btn-wrap {
  margin-top: 15px;
  text-align: center;
}

.featurd-section {
  border-top: 10px solid #2597d8;
  border-bottom: 10px solid #2597d8;
  padding: 80px 0 140px;
  position: relative;
  background-position: top;
}
.featurd-section:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #000234;
  opacity: 0.65;
  position: absolute;
  left: 0;
  top: 0;
}
.featurd-section .container {
  position: relative;
  z-index: 1;
}
.featurd-section .section-title {
  text-align: center;
}
.featurd-section .section-title h2 {
  color: #fff;
  margin-bottom: 40px;
}
.featurd-section .logo-slider {
  max-width: 900px;
  margin: 0 auto;
}
.featurd-section .logo-slider .single-slide a {
  width: 100px;
  height: 100px;
  display: flex;
  margin: 0 auto;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
}
.featurd-section .logo-slider .single-slide:focus {
  outline: none;
}
.featurd-section .logo-slider .slick-arrow {
  font-size: 0;
  border: 0;
}
.featurd-section .logo-slider .slick-arrow.slick-prev::before {
  content: "";
  width: 35px;
  height: 35px;
  background-image: url("~@/assets/images/left-arrow.png");
  position: absolute;
  left: 0;
  top: 50%;
  background-repeat: no-repeat;
  transform: translateY(-50%);
}
.featurd-section .logo-slider .slick-arrow.slick-next:before {
  content: "";
  width: 35px;
  height: 35px;
  background-image: url("~@/assets/images/right-arrow.png");
  position: absolute;
  right: 0;
  top: 50%;
  background-repeat: no-repeat;
  transform: translateY(-50%);
}
.featurd-section .slick-list .single-slide a img {
  max-width: 70px;
}

.search-flight-strip {
  padding: 40px 0;
  text-align: center;
}
.search-flight-strip h3 {
  font-weight: 500;
  color: #000234;
}
.search-flight-strip h3 a {
  font-weight: 700;
  color: #2597d8;
  text-transform: uppercase;
  position: relative;
}
.search-flight-strip h3 a:after {
  content: "\f054";
  font-family: FontAwesome;
  font-weight: 400;
  font-size: 17px;
  line-height: 17px;
  border: 3px solid #2597d8;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  top: -4px;
  position: relative;
  transition: all ease 300ms;
}
.search-flight-strip h3 a:hover {
  color: #1a2d74;
}
.search-flight-strip h3 a:hover:after {
  border-color: #1a2d74;
}

.partner-section .container {
  display: flex;
  align-items: center;
  max-width: 1100px;
}
.partner-section .img-wrap {
  width: 100%;
  max-width: 530px;
  position: relative;
}
.partner-section .img-wrap img {
  box-shadow: 6px 6px 9px #00000029;
  border-radius: 10px;
}
.partner-section .content-box {
  width: calc(100% - 360px);
  background: #f2f2f2;
  border-radius: 20px;
  padding: 30px 40px 50px 190px;
  margin-left: -150px;
  font-weight: 500;
}

.testimonial-section {
  padding: 60px 0 40px;
}
.testimonial-section .container {
  max-width: 800px;
  margin: 0 auto;
}
.testimonial-section .section-title {
  text-align: center;
  font-size: 20px;
  line-height: 30px;
  color: #1a2d74;
  font-weight: 500;
}
.testimonial-section .section-title h2 {
  margin-bottom: 15px;
}
.testimonial-section .testimonial-slider .single-slide {
  padding-left: 115px;
  padding-top: 50px;
  position: relative;
}
.testimonial-section .testimonial-slider .single-slide:before {
  content: "“";
  font-family: "Work Sans", sans-serif;
  font-size: 200px;
  line-height: 200px;
  color: #2597d8;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: 700;
}
.testimonial-section .testimonial-slider .single-slide .content-wrap {
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
  color: #777777;
  margin-bottom: 30px;
}
.testimonial-section .testimonial-slider .single-slide .personal-detail {
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  color: #2597d8;
}

.download-app-section {
  min-height: 660px;
  padding-top: 120px;
  background-position: top;
}
.download-app-section .container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 1370px;
}
.download-app-section .section-title {
  max-width: 440px;
  width: 100%;
  margin-bottom: 30px;
}
.download-app-section .section-title h2 {
  color: #1a2d74;
}
.download-app-section .section-title p {
  font-weight: 700;
  color: #1a2d74;
}
.download-app-section .downld-link-btn {
  max-width: 440px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.search-flight-cta-section {
  text-align: center;
  padding: 85px 0;
  position: relative;
}
.search-flight-cta-section:after {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #000234;
  opacity: 0.8;
  position: absolute;
  left: 0;
  top: 0;
}
.search-flight-cta-section .container {
  position: relative;
  z-index: 1;
  max-width: 830px;
  margin: 0 auto;
}
.search-flight-cta-section h2 {
  color: #fff;
  margin-bottom: 20px;
}
.search-flight-cta-section h4 {
  font-weight: 500;
  color: #fff;
}
.search-flight-cta-section .btn-wrap {
  margin-top: 30px;
}

.steps-section .steps-wrap .single-box.show-content .content-wrap {
  padding: 15px 15px 20px;
}

.mx-input-wrapper {
    max-width: 250px;
  }

.featurd-section.bg-img .slick-track .single-slide a img {
  height: auto;
  max-width: 100%;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  border-bottom-left-radius: 100px;
  border-bottom-right-radius: 100px;
  border: 0;
  width: 95px;
}

.download-app-section .downld-link-btn {
  display: flex;
  flex-direction: column;
}

.downld-link-single-btn {
  width: 170px;
}

.companies-logos-container {
  width: 100%;
  max-width: 440px;
}

@media (min-width: 2000px) {
  .why-choose-section .content-section .icon-wrap {
    margin-bottom: -280px;
  }
  .membership-section .top-shape {
    top: -58px;
    height: 235px;
  }
  .membership-section .top-shape img {
    height: 235px;
    object-fit: cover;
  }
  .membership-section {
    padding-top: 240px;
  }
}
@media (max-width: 1619px) {
  .why-choose-section .content-section .icon-wrap {
    margin-bottom: -210px;
  }
  .membership-section .top-shape img {
    height: 160px;
  }
}

@media (max-width: 1429px) {
  .why-choose-section .content-section .icon-wrap {
    margin-bottom: -190px;
  }
  .membership-section .top-shape img {
    height: 150px;
  }
  .membership-section {
    padding-top: 170px;
  }
  .download-app-section {
    min-height: 580px;
    padding-top: 60px;
  }
}
@media (max-width: 1200px) {
  .steps-section {
    padding-bottom: 310px;
  }
  .why-choose-section .video-section .content-box {
    padding: 56px 55px 56px 180px;
  }
  .why-choose-section .content-section .icon-wrap {
    margin-bottom: -170px;
  }
  .membership-section .top-shape img {
    height: 130px;
  }
  .membership-section {
    padding-top: 150px;
  }

  .download-app-section {
    background-position: center right -70px;
    min-height: 510px;
  }
  .download-app-section .section-title {
    margin-bottom: 0px;
  }
}
@media (max-width: 991px) {
  .banner-section {
    min-height: 620px;
  }
  .banner-section .filter-box-wrap .form-wrap form {
    flex-direction: column;
    max-width: 250px;
    position: relative;
    margin: 0 auto;
  }
  .banner-section .filter-box-wrap .form-wrap input[type="text"],
  .banner-section .filter-box-wrap .form-wrap input {
    margin: 0 0 10px;
    width: 260px;
  }
  .banner-section .filter-box-wrap .form-wrap {
    max-width: 350px;
  }
  .banner-section .filter-box-wrap .form-wrap form a {
    position: absolute;
    top: 40px;
    right: -16px;
  }
  .banner-section .filter-box-wrap .form-wrap form input[type="submit"] {
    margin-top: 10px;
    width: 260px;
    max-width: 260px;
  }
  .featurd-section {
    padding: 50px 0 90px;
  }
  .featurd-section .logo-slider .single-slide {
    margin: 0 25px;
  }
  .partner-section .img-wrap {
    max-width: 400px;
  }
  .partner-section .content-box {
    width: calc(100% - 240px);
  }
  .steps-section .steps-wrap .single-box .img-wrap img {
    height: 160px;
  }
  .steps-section .steps-wrap .single-box .img-wrap {
    max-height: 160px;
  }
  .steps-section .steps-wrap {
    margin-top: -160px;
  }

  .banner-section {
    min-height: 620px;
  }

  .banner-section .filter-box-wrap .form-wrap form {
    flex-direction: column;
    max-width: 250px;
    position: relative;
    margin: 0 auto;
  }
  .banner-section .filter-box-wrap .form-wrap input[type="text"],
  .banner-section .filter-box-wrap .form-wrap input {
    margin: 0 0 10px;
    width: 260px;
  }
  .banner-section .filter-box-wrap .form-wrap {
    max-width: 350px;
  }
  .banner-section .filter-box-wrap .form-wrap form a {
    position: absolute;
    top: 40px;
    right: -16px;
  }
  .banner-section .filter-box-wrap .form-wrap form input[type="submit"] {
    margin-top: 10px;
    width: 260px;
    max-width: 260px;
  }

  .search-form form.search-trip-form,
  .search-form form.search-trip-form > div {
    display: block !important;
    margin: 0 !important;
    text-align: center;
  }
  div#search-box {
    display: inline-block;
    vertical-align: text-bottom;
    width: 100%;
  }
  .search-form input {
    max-width: 100%;
    min-width: 100%;
  }
  .search-form .container .date-rage-picker input {
    min-width: 100%;
  }
  .search-form .mx-datepicker-range {
    width: 100%;
  }
  .search-form .mx-input-wrapper {
    max-width: 100%;
    margin: 15px 0;
  }

  .search-form .container .box-shadow.search-trip-form {
    max-width: 100%;
  }
  button.btn.toggle-airports.icon,
  .search-form .form.control.date-rage-picker {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .steps-section .steps-wrap .single-box .img-wrap .mob-title {
    display: none;
  }

  .download-app-section.mobile {
    display: none;
  }

}

@media (max-width: 767px) {
  .banner-section {
    padding-top: 20px;
    min-height: 560px;
  }
  .banner-section .banner-txt {
    margin-bottom: 50px;
  }
  .steps-section .steps-wrap .single-box .content-wrap h4 {
    display: none;
  }
  .single-box.show-content .content-wrap {
    padding: 20px;
    opacity: 1;
    transform: translateY(0px);
    pointer-events: auto;
    max-height: 300px;
    padding-bottom: 20px;
    display: block !important;
    overflow: hidden;
    transition: all 0.5s;
  }
  .single-box .content-wrap {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    max-height: 0;
    transform: translateY(-20px);
    display: block !important;
    transition: max-height 0.25s, opacity 0.25s, padding 0.25s, transform 0.5s;
  }
  .steps-section .steps-wrap .single-box .img-wrap .mob-title {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    z-index: 1;
  }
  .steps-section .steps-wrap .single-box .img-wrap .mob-title h4 {
    color: #fff;
    text-transform: uppercase;
  }
  .steps-section .steps-wrap .single-box .img-wrap .mob-title a {
    bottom: -70px;
    position: absolute;
    left: 0;
    right: 0;
  }
  .steps-section .steps-wrap .single-box .img-wrap .mob-title a img {
    width: 30px;
    height: 30px;
    margin: 0 auto;
  }
  .steps-section .steps-wrap .single-box.show-content .img-wrap a {
    transform: rotate(-180deg);
  }
  .steps-section {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .steps-section .steps-wrap {
    margin: -170px 0 0;
    flex-direction: column;
    align-items: center;
  }
  .steps-section .steps-wrap .single-box {
    max-width: 400px;
    width: 100%;
    margin: 0 0 25px;
  }
  .steps-section .steps-wrap .single-box .img-wrap {
    max-height: 200px;
    position: relative;
  }
  .steps-section .steps-wrap .single-box .img-wrap img {
    height: 200px;
  }
  .steps-section .steps-wrap .single-box .img-wrap:after {
    content: "";
    width: 100%;
    height: 100%;
    background-color: #000234;
    opacity: 0.4;
    position: absolute;
    left: 0;
    top: 0;
  }
  .steps-section .steps-wrap .single-box .content-wrap {
    padding: 0;
  }
  .steps-section .steps-wrap .single-box .content-wrap {
    display: none;
  }
  .why-choose-section {
    padding-bottom: 50px;
  }
  .why-choose-section .video-section {
    flex-direction: column;
    margin-bottom: 30px;
    margin-top: 0;
  }
  .why-choose-section .video-section .content-box {
    margin-left: 0;
    margin-top: -165px;
    padding: 185px 15px 30px;
  }
  .why-choose-section .video-section .video-wrap {
    max-width: 94%;
  }
  .why-choose-section .video-section .video-wrap iframe {
    height: 300px;
  }
  .why-choose-section .content-section .icon-wrap {
    margin-bottom: -120px;
    margin-top: 40px;
    width: 80px;
    height: 80px;
  }
  .why-choose-section .content-section {
    font-size: 18px;
    line-height: 26px;
  }
  .membership-section .top-shape {
    height: 123px;
  }
  .membership-section .top-shape img {
    height: 110px;
  }

  .membership-section {
    padding-top: 100px;
  }
  .membership-section .cols-wrap {
    margin-left: 0;
    margin-right: 0;
    flex-direction: column;
  }
  .membership-section .section-title {
    margin-bottom: 15px;
  }
  .membership-section .cols-wrap .single-col {
    width: 100%;
    margin: 0;
    text-align: center;
  }
  .featurd-section .logo-slider {
    flex-direction: column;
  }
  .featurd-section {
    padding-bottom: 60px;
  }
  .search-flight-strip h3 a {
    display: block;
    margin-top: 7px;
  }
  .partner-section .container {
    flex-direction: column;
  }
  .partner-section .img-wrap {
    max-width: 94%;
  }
  .partner-section .content-box {
    width: 100%;
    margin: -150px 0 0;
    padding: 160px 20px 20px;
  }
  .testimonial-section .testimonial-slider .single-slide {
    padding-left: 0;
    padding-top: 70px;
  }
  .testimonial-section .testimonial-slider .single-slide:before {
    position: absolute;
    font-size: 180px;
    line-height: 0;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
  }
  .download-app-section {
    min-height: 350px;
    background-position: center right -30px;
    padding-top: 40px;
  }
  .download-app-section .section-title h2 {
    font-size: 28px;
    line-height: 36px;
  }
  .download-app-section .section-title p {
    font-size: 16px;
    line-height: 24px;
  }
  .download-app-section .section-title,
  .download-app-section .downld-link-btn {
    max-width: 310px;
  }
  .download-app-section .downld-link-btn a img {
    width: 170px;
  }
  .search-flight-cta-section {
    padding: 55px 0;
  }

  .download-app-section.bg-img {
    display: none;
  }

  .download-app-section.mobile .container {
    padding: 0;
  }

  .download-app-section.mobile .section-title,
  .download-app-section.mobile .downld-link-btn {
    max-width: none;
    margin-left: auto;
    width: 90%;
    margin-right: auto;
    text-align: center;
  }


  .download-app-section.mobile .smartphone-image-container {
    width: 100%;
    max-width: none;
  }


  .download-app-section.mobile .smartphone-image-container img {
    width: 100%;
  }

  .download-app-section.mobile .downld-link-single-btn {
    width: 100%; 
    max-width: 170px;
    margin-left: auto;
    margin-right: auto;
  }


}

@media (max-width: 575px) {
  .banner-section {
    min-height: auto;
    padding-bottom: 100px;
  }
  .why-choose-section .content-section .icon-wrap {
    width: 75px;
    height: 75px;
    margin-bottom: -105px;
  }
  .why-choose-section .content-section .icon-wrap img {
    max-width: 50px;
  }
  .why-choose-section .video-section .video-wrap iframe {
    height: 200px;
  }
  .why-choose-section .video-section .video-wrap {
    max-width: 90%;
  }
  .why-choose-section .video-section .content-box {
    margin-top: -95px;
    padding: 115px 15px 30px;
  }
  .featurd-section .logo-slider .slick-list {
    max-width: 80%;
    margin: 0 auto;
  }
  .featurd-section .logo-slider .single-slide a {
    width: 80px;
    height: 80px;
  }
  .featurd-section .logo-slider .single-slide a img {
    max-width: 50px;
  }
  .partner-section .img-wrap {
    max-width: 90%;
  }
  .testimonial-section {
    padding: 40px 0 30px;
  }
  .download-app-section {
    min-height: 380px;
    background-position: bottom right -86px;
  }
  .featurd-section .logo-slider .slick-arrow.slick-prev {
    left: 0;
  }
  .featurd-section .logo-slider .slick-arrow.slick-next {
    right: 0;
  }
  .featurd-section .logo-slider .single-slide {
    margin: 0;
  }
}
</style>